export enum YslabEventTypes {
    APP_INIT = "app-initialized",
    APP_LOADED = "app-loaded",
    APP_OPEN_MOBILE = "app-open-mobile",
    APP_CLOSE_MOBILE = "app-close-mobile",
    APP_COPY_URL = "app-copy-url",
    APP_OPEN_FORM = "app-open-form",
    APP_ERROR = "app-error"
}

// some events are exclusive to application type, we have two Yslab applycations: Jeff and All-in-One
export enum YslabJeffAppEventTypes {
    APP_APARTMENT_SELECTED = "app-apartment-selected"
}

export type YslabEvents = MessageEvent<
    | {
          type: YslabEventTypes.APP_CLOSE_MOBILE;
      }
    | {
          type: YslabEventTypes.APP_COPY_URL;
          apartment: {name: string};
      }
    | {
          type: YslabEventTypes.APP_ERROR;
          url: string;
          originalError: string;
      }
    | {
          type: YslabEventTypes.APP_INIT;
      }
    | {
          type: YslabEventTypes.APP_LOADED;
      }
    | {
          type: YslabEventTypes.APP_OPEN_FORM;
          apartmentsNames: string[];
          investmentName: string[];
      }
    | {
          type: YslabEventTypes.APP_OPEN_MOBILE;
      }
    | {
          type: YslabJeffAppEventTypes.APP_APARTMENT_SELECTED;
          apartment: YslabJeffAppApartment;
      }
>;

export type YslabJeffAppApartment = {
    configuredBuildingName?: string;
    name: string;
    mappingName: string;
    price: Nullable<string>;
    floor: number;
    rooms: number;
    status: StatusResimo;
    symbol?: string;
    area: number;
    buildingNumber?: string | null;
    apartmentId: Nullable<string>;
};

enum StatusResimo {
    SOLD = "sold",
    RESERVED = "reserved",
    AVAILABLE = "available",
    NOT_AVAILABLE = "not_available",
    PROMOTION = "promotion",
    UNKNOWN = "unknown",
    ORAL_RESERVATION = "oral_reservation"
}

type Nullable<T> = null | undefined | T;
export enum YslabEventTypes {
    APP_INIT = "app-initialized",
    APP_LOADED = "app-loaded",
    APP_OPEN_MOBILE = "app-open-mobile",
    APP_CLOSE_MOBILE = "app-close-mobile",
    APP_COPY_URL = "app-copy-url",
    APP_OPEN_FORM = "app-open-form",
    APP_ERROR = "app-error"
}

// some events are exclusive to application type, we have two Yslab applycations: Jeff and All-in-One
export enum YslabJeffAppEventTypes {
    APP_APARTMENT_SELECTED = "app-apartment-selected"
}

export type YslabEvents = MessageEvent<
    | {
          type: YslabEventTypes.APP_CLOSE_MOBILE;
      }
    | {
          type: YslabEventTypes.APP_COPY_URL;
          apartment: {name: string};
      }
    | {
          type: YslabEventTypes.APP_ERROR;
          url: string;
          originalError: string;
      }
    | {
          type: YslabEventTypes.APP_INIT;
      }
    | {
          type: YslabEventTypes.APP_LOADED;
      }
    | {
          type: YslabEventTypes.APP_OPEN_FORM;
          apartmentsNames: string[];
          investmentName: string[];
      }
    | {
          type: YslabEventTypes.APP_OPEN_MOBILE;
      }
    | {
          type: YslabJeffAppEventTypes.APP_APARTMENT_SELECTED;
          apartment: YslabJeffAppApartment;
      }
>;

export type YslabJeffAppApartment = {
    configuredBuildingName?: string;
    name: string;
    mappingName: string;
    price: Nullable<string>;
    floor: number;
    rooms: number;
    status: StatusResimo;
    symbol?: string;
    area: number;
    buildingNumber?: string | null;
    apartmentId: Nullable<string>;
};

enum StatusResimo {
    SOLD = "sold",
    RESERVED = "reserved",
    AVAILABLE = "available",
    NOT_AVAILABLE = "not_available",
    PROMOTION = "promotion",
    UNKNOWN = "unknown",
    ORAL_RESERVATION = "oral_reservation"
}

type Nullable<T> = null | undefined | T;
